/**
 * Trạng thái nộp dự toán
 */
export default {
  /**
   * Chờ duyệt
   */
  NotCheck: 1,
  /**
   * Gửi trả
   */
  Return: 2,
  /**
   * Đã kiểm tra
   */
  Completed: 3,
};
